"use client"
import React from "react";
import "@/components/maps/MapRoutePreview.css";

const MapRoutePreview = ({ route }) => {
  if (!route || !route.directions) {
    return null;
  }

  const { directions } = route;
  const { origin, destination, stops = [], profile } = directions;

  const getProfileIcon = profileType => {
    switch (profileType) {
      case "walking":
        return "fas fa-person-walking";
      case "cycling":
        return "fas fa-person-biking";
      case "driving":
      default:
        return "fas fa-car";
    }
  };

  const getProfileLabel = profileType => {
    switch (profileType) {
      case "walking":
        return "Walking";
      case "cycling":
        return "Cycling";
      case "driving":
      default:
        return "Driving";
    }
  };

  return (
    <div
      className="map-route-preview"
      style={{
        "--route-color": route.hexColor ? `#${route.hexColor}` : "#000000"
      }}
    >
      <h5>{route.title}</h5>
      <ul className="connected-line">
        {origin && (
          <li
            key="map-route-preview-origin"
            className="origin"
            style={{
              "--route-color": route.hexColor ? `#${route.hexColor}` : "#000000"
            }}
          >
            {origin.title}
          </li>
        )}
        {stops.length > 0 &&
          stops.map((stop, index) => {
            return (
              <li
                key={`map-route-preview-stop-${index}`}
                className="stop"
                style={{
                  "--route-color": route.hexColor
                    ? `#${route.hexColor}`
                    : "#000000"
                }}
              >
                {stop.title}
              </li>
            );
          })}
        {destination && (
          <li
            key="map-route-preview-destination"
            className="destination"
            style={{
              "--route-color": route.hexColor ? `#${route.hexColor}` : "#000000"
            }}
          >
            {destination.title}
          </li>
        )}
      </ul>
    </div>
  );
};

export default MapRoutePreview;
